import React from 'react';
import { useSelector, useDispatch } from "react-redux";

import { ModalBlank } from "components/commons/Modals";
import { Button } from 'components/commons';
import { setFormModalError, setFormModalOpen } from "redux/forms/actions";


function FormSentContainer() {
  const [modalOpen, setModalOpen] = React.useState(false);

  const dispatch = useDispatch();

  const { formModalOpen, error } = useSelector(({ forms }) => ({
    formModalOpen: forms.formModalOpen,
    error: forms.error
  }))

  React.useEffect(() => {
    if (formModalOpen) {
      setModalOpen(true)
    } else {
      setModalOpen(false)
    }
  }, [formModalOpen])

  const closeModal = (e) => {
    e.stopPropagation();
    dispatch(setFormModalOpen(false));
    dispatch(setFormModalError(null));
  }

  return (
    <ModalBlank id="success-modal" modalOpen={modalOpen} setModalOpen={setModalOpen}>
      <div className="p-5 flex space-x-4">
        {/* Icon */}
        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 bg-green-100">
          <svg className="w-4 h-4 flex-shrink-0 fill-current text-green-500" viewBox="0 0 16 16">
            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z" />
          </svg>
        </div>
        {/* Content */}
        <div>
          {/* Modal header */}
          <div className="mb-2">
            <div className="text-lg font-semibold text-gray-800">
              {!error ? "Ваша заявка успешно отправлена" : "Произошла непредвиденная ошибка"}
            </div>
          </div>
          {/* Modal content */}
          <div className="text-sm mb-10">
            <div className="space-y-2">
              {!error && <p>Ваша заявка успешно подана, она будет обработана в ближайшее время</p>}
              {error && <p>Упс... Что-то пошло не так, попробуйте позже</p>}
            </div>
          </div>
          {/* Modal footer */}
          <div className="flex flex-wrap justify-end space-x-2">
            <Button size="sm" appearance="primary" clickHandler={closeModal}>
              Ок
            </Button>
          </div>
        </div>
      </div>
    </ModalBlank>
  )
}

export default FormSentContainer;
